
import { Vue, Component, Prop } from 'vue-property-decorator';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';

@Component({ components: { CustomButton, CustomDialog } })
export default class DetailsConfirmationDialog extends Vue {
  @Prop({ required: true, type: String }) readonly accountType!: string;

  @Prop({ required: true, type: String }) readonly accountNumber!: string;

  @Prop({ required: true, type: String }) readonly accountBank!: string;

  get lastFour(): string {
    return this.accountNumber.slice(-4);
  }
}
